import { render, staticRenderFns } from "./MailUpParametersDisplay.vue?vue&type=template&id=9e90b678&scoped=true&"
import script from "./MailUpParametersDisplay.vue?vue&type=script&lang=js&"
export * from "./MailUpParametersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MailUpParametersDisplay.vue?vue&type=style&index=0&id=9e90b678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e90b678",
  null
  
)

export default component.exports